import React, {useState, useEffect} from "react";
import {array, bool, func, string} from "prop-types";
import CreatableSelect from 'react-select/creatable';
import {components} from 'react-select'; // Import default components
// https://www.npmjs.com/package/html-react-parser
// using this parser because there are some Products that come with <sup>&reg;</sup>
//static input field type will be excluded from message ( e.g. button text, label )
import parse from "html-react-parser";
import {Label} from "../UILib";
import axios from "axios";

export const MessageTextInputField = ({
                                          id,
                                          labelText,
                                          maxLength,
                                          type,
                                          djfield, // django database fields
                                          fieldRequired, // bool
                                          handlePreviewChangeEvent,
                                          handleErrorEvent,
                                          disabled
                                      }) => {
    const [inputValue, setInputValue] = useState("");
    const [state, setState] = useState("");

    const handleChange = (event) => {
        console.log(maxLength)
        if (maxLength > 0) {
            if (event.target.value.length == maxLength) {
                event.target.labelText = "error";
                handleErrorEvent("error");
                event.target.classList.add("input--error");

            } else {
                setState(event.target.value);
                setInputValue({InputValue: event.target.value});
                if (event.target.classList.contains('input--error')) {
                    event.target.classList.remove('input--error');
                }
            }
        } else {
            setState(event.target.value);
            setInputValue({InputValue: event.target.value});
        }

    };

    return (
        <div className="msg-options">
            <Label type="l3" htmlFor={id} className="msg-options__label">
                {labelText}:{fieldRequired}
            </Label>
            <input
                id={id}
                name={id}
                maxLength={maxLength}
                className="msg-options__select"
                value={state.InputValue}
                data-type={type !== "static" ? "message-options" : 'static'}
                data-djangofield={djfield}
                data-newmessage={true}
                onChange={handleChange}
                onKeyUp={type !== "static" ? handlePreviewChangeEvent : null}
                required={fieldRequired === "*" && true}
                disabled={disabled}
            />
        </div>
    );
};

MessageTextInputField.propTypes = {
    labelText: string,
    type: string,
    djfield: string,
    data: array,
    handlePreviewChangeEvent: func,
    handleErrorEvent: func,
};

export const MessageDateInputField = ({
                                          id,
                                          labelText,
                                          type,
                                          djfield, // django database fields
                                          fieldRequired, // bool
                                          handlePreviewChangeEvent,
                                          disabled,
                                      }) => {
    const [inputValue, setInputValue] = useState("");
    const [state, setState] = useState("");
    const handleChange = (event) => {
        setState(event.target.value);
        setInputValue(event.target.value);
    };

    return (
        <div className="msg-options">
            <Label type="l3" htmlFor={id} className="msg-options__label">
                {labelText}:{fieldRequired}
            </Label>
            <input
                id={id}
                name={id}
                className="msg-options__select"
                value={state.InputValue}
                data-type="message-options"
                data-djangofield={djfield}
                data-newmessage={true}
                type="date"
                onChange={handleChange}
                onKeyUp={handlePreviewChangeEvent}
                onSelect={handlePreviewChangeEvent}
                required={fieldRequired === "*" && true}
                disabled={disabled}
            />
        </div>
    );
};

MessageDateInputField.propTypes = {
    type: string,
    djfield: string,
    data: array,
    handlePreviewChangeEvent: func,
};

export function ProductOptionField({
                                       id,
                                       labelText,
                                       disabled,
                                       templateType,
                                       data,
                                       djfield, // django database fields
                                       fieldRequired, // bool
                                       setSelectedProduct, // sets the active product
                                       setProductSelected, // Bool: toggles visibility of other form options
                                   }) {
    // Must strip the HTML from <option> text
    // and then feed back into HTML parser
    // because <option> would not accept the
    // html parsers return data
    const stringStripHTML = (text) => {
        let regex = /(<([^>]+)>)/gi;
        return text.replace(regex, "");
    };

    const handleChange = (event) => {
        if (event.target.value === "") {
            setSelectedProduct("");
            setProductSelected(false);
            return;
        }
        setSelectedProduct(event.target.value);
        setProductSelected(true);
    };

    return (
        <div className="msg-options">
            <Label type="l3" htmlFor={id} className="msg-options__label">
                {labelText}:{fieldRequired}
            </Label>
            <select
                id={id}
                name={id}
                className="msg-options__select"
                required={fieldRequired === "*" && true}
                onChange={handleChange}
            >
                <option className="msg-options__option" value="" defaultValue>
                    --select--
                </option>
                {data.map((item) => {
                    return (
                        <option
                            className="msg-options__option"
                            key={`${item.id}-${item.type}`}
                            value={item.product_name}
                            data-djangofield={djfield}
                            data-newmessage={true}
                            disabled={item.product_name === 'JASCAYD' && templateType === "competitive"}
                        >
                            {
                                // <option> will not allow HTML as text
                                // strip out the HTML
                                // parse as HTML since the &reg; will still work
                                // once the <sup> tag is gone
                                parse(stringStripHTML(item.product_name))
                            }
                        </option>
                    );
                })}
            </select>
        </div>
    );
}

ProductOptionField.propTypes = {
    labelText: string,
    djfield: string,
    data: array,
    templateType: string,
    disabled: bool,
    setSelectedProduct: func,
    setProductSelected: func,
};


export function MessageCreateSelectOptionField({
                                                   id,
                                                   labelText,
                                                   data,
                                                   djfield, // django database fields
                                                   handlePreviewChangeEvent, // event hanlder for <Preview/>
                                                   handleCreate, //when a new option is created, and onChange will not be called.
                                                   handleChange, //when handle chance.
                                                   fieldRequired, // bool
                                                   selectedProduct, // the product that was selected
                                                   disabled,
                                                   creatable,
                                                   messageData
                                               }) {


    let dataProps = [];
    let inputProps = {}
    console.log(selectedProduct)
    let controlOption = data.map((item) => {
        // filter out options that don't apply
        // to this brand
        //console.log(item)
        //console.log(item.product_name === selectedProduct)
        if (item.product_name === selectedProduct) {

            dataProps.unshift({
                value: item.value,
                label: item.value,
                className: "msg-options__option **",
                key: `${item.id}-${item.type}`,
                dataType: "message-options",
                dataDjangofield: djfield,
                dataNewmessage: true,
                dataProduct: selectedProduct,
                id: item.id,
                name: item.name
            })

            inputProps['className'] = "msg-options__option **";
            inputProps['key'] = `${item.id}-${item.type}`;
            inputProps['data-type'] = "message-options";
            inputProps['data-djangofield'] = djfield;
            inputProps['data-newmessage'] = true;
            inputProps['data-product'] = selectedProduct;
        }


    })


    useEffect(() => {
        console.log('Creatable component mounted or options changed.');
        document.querySelector(`input[name='${id}']`).setAttribute('data-djangofield', djfield)
        document.querySelector(`input[name='${id}']`).setAttribute('data-type', "message-options")
        document.querySelector(`input[name='${id}']`).setAttribute('data-newmessage', "true")
        document.querySelector(`input[name='${id}']`).setAttribute('data-product', selectedProduct)


        // This effect runs after initial render and whenever options change
    }, [dataProps]); // Dependency array: re-run effect when 'options' changes

    const createNewMeta = async (type, value, product) => {

        const headers = {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Api-Key ${process.env.REACT_APP_AMP_API_KEY}`,
            },
            //  cors: {  //only local
            //      "Access-Control-Allow-Origin": "*",
            //      "Access-Control-Allow-Headers": "Content-Type"
            //  }
        };

        let url = `${process.env.REACT_APP_API_HOST}/api/product-meta/`;
        let payload = {type: type, value: value, product_name: product}
        try {
            await axios.post(`${url}`, payload, headers).then((res) => {
                // Success - Redirect to Dashboard
                console.log('success')
            });
        } catch (error) {
            console.log(error);
            // show error
            setNotification("There was a problem submitting your new meta.");
            setNotificationClass("notification--show");
            // reset after timeout otherwise the change
            // happens too fast and the modal will
            // not work again
            setTimeout(resetNotifications, 5500);
        }
    };

    const customStyles = {
        option: (defaultStyles, state) => ({
            // You can log the defaultStyles and state for inspection
            // You don't need to spread the defaultStyles
            ...defaultStyles,
            color: state.isSelected ? "#08302a" : "#000",
            backgroundColor: state.isSelected ? "#e5e3de" : "#fff",
            width: "100%",
            fontFamily: 'Arial',
            fontSize: "14px",
        }),

        control: (defaultStyles) => ({
            ...defaultStyles,
            // Notice how these are all CSS properties
            backgroundColor: "#fff",
            padding: "0px",
            border: "1px solid #000",
            boxShadow: "none",
            fontFamily: 'Arial',
            fontSize: "14px",
            width: "100%",
            borderRadius: "2px"
        }),
        singleValue: (defaultStyles) => ({
            ...defaultStyles,
            color: "#000",
            fontSize: "14px",
            padding: "0px",
            margin: "0px"
        }),
    };
    const customOption = (props) => {
        const {innerProps, innerRef, data, isSelected, isFocused} = props;

        // You can access properties of the option data (e.g., data.label, data.value)
        // and styling state (isSelected, isFocused) to customize the rendering.
        return (
            <div
                ref={innerRef}
                {...innerProps}
                style={{
                    padding: '8px 12px',
                    backgroundColor: isSelected ? '#2684FF' : isFocused ? '#DEEBFF' : 'white',
                    color: isSelected ? 'white' : 'black',
                    cursor: 'pointer',
                }}
            >
                {data.label} {data.__isNew__ && '(New Option)'} {/* Add a label for new options */}
            </div>
        );
    };
    const Control = ({children, ...props}) => (
        <components.Control {...props}>
            {children}
        </components.Control>
    );
    console.log(messageData)

    const [selectedValue, setSelectedValue] = useState({value: messageData, label: messageData} || null);
    const [options, setOptions] = useState(dataProps)


    const _onChange = (newValue, actionMeta) => {
        console.log('Selected option changed:', newValue);
        console.log('Action meta:', actionMeta);


        setSelectedValue(newValue);
        if (selectedValue && selectedValue.__isNew__) {
            // Conditional logic: only execute if a new option was created
            console.log('A new option was created:', selectedValue.value);
            // You can perform actions here, e.g., save the new option to a database
            // and update the 'options' state if needed.
            setOptions((prevOptions) => [...prevOptions, selectedValue]);
            document.querySelector(`input[name='${id}']`).setAttribute('data-insert', 'new')
        } else if (selectedValue) {
            console.log('An existing option was selected:', selectedValue.value);
        }
        handlePreviewChangeEvent()
    }

    const _onCreateHandler = (inputValue) => {
        console.log('new value created')
        const newOption = {value: inputValue, label: inputValue};
        setOptions([...options, newOption]);
        const creatMeta = createNewMeta(djfield, inputValue, selectedProduct)
        setSelectedValue(newOption); // Automatically select the newly created option

        handlePreviewChangeEvent()
    }

    //this is no longer options - using creatable hiddel data field
    return (
        <div className="msg-options" id={id}
             data-type="message-options"

             data-djangofield={djfield}
             data-newmessage={true}
             data-product={selectedProduct}>
            <Label type="l3" htmlFor={id} className="msg-options__label">
                {labelText}:{fieldRequired}
            </Label>
            <CreatableSelect
                styles={customStyles}
                name={id}
                inputId={id}
                isClearable
                value={selectedValue}
                className='msg-options__select'
                onChange={_onChange}
                onCreateOption={_onCreateHandler}
                options={dataProps}
                required={fieldRequired === "*" && true && !disabled}
                components={{Control, Option: customOption}}
                placeholder="--select--"
            />
        </div>
    );
}

MessageCreateSelectOptionField.propTypes = {
    labelText: string,
    djfield: string,
    data: array,
    setSelectedProduct: func,
    setProductSelected: func,
    id: string,
    handlePreviewChangeEvent: func,
    handleCreate: func,
    handleChange: func,
    fieldRequired: string,
    selectedProduct: string, // the product that was selected
    disabled: bool,
    creatable: bool,
    messageData: string
};

export function MessageSelectOptionField({
                                             id,
                                             labelText,
                                             data,
                                             djfield, // django database fields
                                             handlePreviewChangeEvent, // event hanlder for <Preview/>
                                             fieldRequired, // bool
                                             selectedProduct, // the product that was selected
                                             disabled,
                                         }) {
    // Must strip the HTML from <option> text
    // and then feed back into HTML parser
    // because <option> would not accept the
    // html parsers return data
    const stringStripHTML = (text) => {
        let regex = /(<([^>]+)>)/gi;
        return text.replace(regex, "");
    };


    return (
        <div className="msg-options">
            <Label type="l3" htmlFor={id} className="msg-options__label">
                {labelText}:{fieldRequired}
            </Label>
            <select
                id={id}
                name={id}
                data-product={selectedProduct}
                className="msg-options__select"
                onChange={handlePreviewChangeEvent}
                required={fieldRequired === "*" && true && !disabled}
                disabled={disabled}
            >
                <option className="msg-options__option" value="" defaultValue>
                    --select--
                </option>
                {data.map((item) => {
                    // filter out options that don't apply
                    // to this brand
                    if (item.product_name !== selectedProduct) {
                        return;
                    }
                    return (
                        <option
                            className="msg-options__option **"
                            key={`${item.id}-${item.type}`}
                            value={item.value}
                            data-type="message-options"
                            data-djangofield={djfield}
                            data-newmessage={true}
                            data-product={selectedProduct}
                        >
                            {
                                // <option> will not allow HTML as text
                                // strip out the HTML
                                // parse as HTML since the &reg; will still work
                                // once the <sup> tag is gone
                                parse(stringStripHTML(item.value))
                            }
                        </option>
                    );
                })}
            </select>
        </div>
    );
}

MessageSelectOptionField.propTypes = {
    labelText: string,
    djfield: string,
    data: array,
    constructingPreview: bool,
    handlePreviewChangeEvent: func,
    selectedProduct: string,
};

export function MessageAutoSelectedField({id, labelText, type, text}) {
    return (
        <div className="msg-options msg-options--disabled">
            <Label type="l3" htmlFor={id} className="msg-options__label">
                {labelText}:
            </Label>
            <input
                id={id}
                name="autotext"
                className="msg-options__select"
                value={text}
                data-type="message-options"
                data-autotext={true}
                data-newmessage={true}
                type={type}
                disabled
            />
        </div>
    );
}
